var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled = function SvgFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.627 5.499 12 6l-.627-.501a6.257 6.257 0 0 0-8.333.461C.752 8.248.584 11.906 2.772 14.29 5.935 17.735 10.212 22 12 22c1.789 0 6.065-4.265 9.228-7.71 2.188-2.384 2.02-6.042-.268-8.33a6.257 6.257 0 0 0-8.333-.461Z",
    fill: "#777E90"
  })));
};
export default SvgFilled;